import { AuthProductName, ViewName } from '@/types'

const coProducerDecorations = {
  id: 'co-producer',
  name: 'Co-Producer',
  viewDecorations: [
    {
      hideCreate: true,
      badgeText: '',
      viewName: ViewName.Login,
      offerMessage: '',
      title: 'Log in to your account',
      body: 'Enter the email address associated with your account.'
    },
    {
      badgeText: '',
      viewName: ViewName.Success,
      offerMessage: '',
      title: "You're logged in!",
      body: 'Now open Co-Producer.'
    }
  ],
  authProductName: AuthProductName.WEBSITE
}
export default coProducerDecorations
